<script>
import TransactionList from '../../components/transaction/TransactionList.vue'

export default {
  components: {
    TransactionList
  },
}
</script>


<template>
  <TransactionList
      :key="$route.params.status"
      :endpoint="'transaction/status/' + $route.params.status"
  />
</template>
